import axiosInstance from "./AxiosConfig";

class UserAuthenticationApi {
  async upsert(payload) {
    try {
      const response = await axiosInstance.post(
        "/userAuthentication/upsert",
        payload
      );
      return response.data;
    } catch (error) {
      console.error(error);
      return error?.response?.data || null;
    }
  }

  async getAll() {
    try {
      const response = await axiosInstance.get("/userAuthentication/get");
      return response.data;
    } catch (error) {
      console.error(error);
      return error?.response?.data || null;
    }
  }

  async GetUserAuthenticationByUser(id) {
    try {
      const response = await axiosInstance.get(`/userAuthentication/getByUserId/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

}

export default new UserAuthenticationApi();
